// Import everything from autoload folder
import './autoload/_bootstrap.js'; import './autoload/ada-compliance.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import './plugins/google-map';
import 'jquery-match-height';
import LazyLoad from 'vanilla-lazyload';
import objectFitImages from 'object-fit-images';
import { Fancybox } from '@fancyapps/ui';
// import ScrollOut from 'scroll-out';
import { initAnimations } from './animations';
import { initSmoothScroll, scrollToElement } from './smooth-scroll';

/* global Swiper */

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   * a[href$="jpg"], a[href$="png"], a[href$="gif"], a[href$="webp"]
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"], a[href$="webp"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');

  Fancybox.bind('[data-fancybox], .fancybox, a[rel*="album"]');

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
    gformFloatingLabels();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      scrollToElement($target.get(0), 50);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Override bootstrap submenu toggle
   */
  $('.navbar .menu-item-has-children').hover(function () {
    if ($(window).width() > 991) {
      $(this).toggleClass('show');
      alignMenuDropdown($(this).children('.dropdown-menu'));
    }
  });

  // Prevent dropdown menu opening out of window
  function alignMenuDropdown($dropdown) {
    if ($dropdown === undefined || !$dropdown.length) return false;
    $dropdown.toggleClass(
      'dropdown-menu-left',
      $dropdown.offset().left + $dropdown.width() > $(window).width()
    );
  }

  // Dropdown menu mobile toggle
  $('.js-dropdown-toggle').bind('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(window).width() <= 991) {
      $(this).closest('.dropdown').toggleClass('show');
    }
  });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    // jQuery code goes here
  });

  // Apply scrolling classes on autoscroll
  $(window).trigger('scroll');

  initSmoothScroll();
  lazyLoadInit();
  slidersInit();
  scrollToAnchor();
  resizeVideo();
  filterProjects();
  initAnimations();
}); // END of document ready

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Optimize home slider (mobile)
  setTimeout(() => {
    let $sliderPreview = $('#home-slider-preview');
    let $homeSlider = $('#home-slider');
    if (
      $(window).width() <= 768 &&
      $sliderPreview.length &&
      $homeSlider.length
    ) {
      $sliderPreview.hide();
      $homeSlider.show();
    }
  }, 1200);

  // Tabs
  tabsHandler();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
let lastScrollTop = 0;
$(window).on('scroll', function () {
  // jQuery code goes here
  let st = $(this).scrollTop();
  $(document.body)
    .toggleClass('scrolling-up', st < lastScrollTop)
    .toggleClass('scrolling-down', st > lastScrollTop)
    .toggleClass('scrolling', st !== 0);
  if (st === 0) $('body').removeClass('scrolling-up scrolling-down');
  lastScrollTop = st;
});

/* Scrolling to anchor */
function getHashTarget(hash) {
  if (!hash || hash.charAt(0) !== '#' || hash.length === 1) return null;

  try {
    return document.getElementById(decodeURIComponent(hash.slice(1)));
  } catch (error) {
    return null;
  }
}

function scrollToAnchor() {
  // Anchor click scrolling
  let topOffset = $(window).width() > 991 ? 100 : 70;
  $(document).on('click', 'a[href^="#"]', function (e) {
    if (
      $(this).attr('href') !== '#' &&
      !$(this).hasClass('fancybox') &&
      $(this).attr('role') !== 'tab'
    ) {
      e.preventDefault();
      let $this = $(this);
      const target = getHashTarget($this.attr('href'));
      if (target) {
        scrollToElement(target, topOffset);
      } else if ($this.attr('href') === '#next') {
        let $sectionToScroll = $this.closest('section').next('section');

        if ($sectionToScroll.length) {
          scrollToElement($sectionToScroll.get(0), topOffset);
        }
      }
    }
  });

  // On load *only* if we have anchor on the url
  if (window.location.hash) {
    // smooth scroll to the anchor id
    scrollToElement(getHashTarget(window.location.hash), topOffset);
  }
}

/* Sliders init */
function slidersInit() {
  // Init Swiper
  if ($('.js-home-slider').length && typeof Swiper !== undefined) {
    new Swiper('.js-home-slider', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 3000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1500,
      spaceBetween: 0,
      slidesPerView: 1,
    });
  }

  // Init Flexible Slider
  let $sliders = $('.js-slider');
  if ($sliders.length && typeof Swiper !== undefined) {
    $sliders.each(function (i, el) {
      let $this = $(el);
      let defaults = {
        loop: false,
        speed: 1000,
        spaceBetween: 0,
        slidesPerView: 1.2,
        navigation: {
          prevEl: $this.find('.swiper-button-prev').get(0),
          nextEl: $this.find('.swiper-button-next').get(0),
        },
        breakpoints: {
          768: {
            slidesPerView: 2.4,
          },
        },
      };

      let options = $this.data('options') ?? {};

      new Swiper(el, { ...defaults, ...options });
    });
  }

  // Testimonials
  if ($('.js-centered-slider').length && typeof Swiper !== undefined) {
    new Swiper('.js-centered-slider', {
      loop: true,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: true,
    });
  }
}

// LazyLoad
function lazyLoadInit() {
  // Init LazyLoad (for ignore .no-lazyload).
  const lazySelector = 'img[data-lazy-src],.pre-lazyload';
  let lazyLoadInstance = new LazyLoad({
    elements_selector: lazySelector,
    data_src: 'lazy-src',
    data_srcset: 'lazy-srcset',
    data_sizes: 'lazy-sizes',
    skip_invisible: false,
    // Keep downloading when an image leaves the viewport: clip-path reveals make
    // lazyload treat a clipped image as exited, which cancelled its download.
    cancel_on_exit: false,
    class_loading: 'lazyloading',
    class_loaded: 'lazyloaded',
  });

  // Update lazyload when new images are added (for example, by AJAX).
  if (window.MutationObserver) {
    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          // The added node can itself be a lazy image, or contain one.
          if (node.nodeType !== 1) {
            return;
          }
          // Checked by hand instead of Element.matches, which older browsers
          // only expose under vendor-prefixed names.
          const isLazy =
            (node.tagName === 'IMG' && node.hasAttribute('data-lazy-src')) ||
            (node.classList && node.classList.contains('pre-lazyload'));
          if (isLazy || node.querySelector(lazySelector)) {
            lazyLoadInstance.update();
          }
        });
      });
    });
    let b = document.getElementsByTagName('body')[0];
    let config = { childList: true, subtree: true };
    observer.observe(b, config);
  }
}

// Projects filtering
function filterProjects() {
  $('.js-project-filter').on('click', function () {
    $('.js-project-filter').removeClass('badge--dark');
    $(this).addClass('badge--dark');

    const filterId = $(this).data('id').toString();
    const $items = $('.js-project-item');
    const $container = $('.js-projects');
    const delay = 500;

    $container.addClass('ajax-overlay--active');

    if (filterId === '0') {
      $items.delay(delay).fadeIn(300);
    } else {
      $items.each(function () {
        const itemCategories = $(this).data('category').toString().split(',');

        if (itemCategories.includes(filterId)) {
          $(this).delay(delay).fadeIn(300);
        } else {
          $(this).delay(delay).fadeOut(300);
        }
      });
    }

    setTimeout(() => {
      $container.removeClass('ajax-overlay--active');
    }, delay);
  });
}

// Tabs Handler
function tabsHandler() {
  $(document).on('mouseenter', '.tabs__header', function () {
    const $this = $(this);
    const count = $this.data('count');
    const $tabs = $this.closest('.tabs');

    $tabs.find('.tabs__header').removeClass('active');
    $this.addClass('active');

    $tabs.find('.tabs__block').removeClass('active').hide();
    $tabs
      .find('.tabs__block[data-count="' + count + '"]')
      .addClass('active')
      .fadeIn();
  });
}

// Gravity forms floating labels
function gformFloatingLabels() {
  const inputs = document.querySelectorAll('.gfield input');

  inputs.forEach(function (input) {
    input.addEventListener('focus', function () {
      input.classList.add('input-focused');
    });

    input.addEventListener('blur', function () {
      input.classList.remove('input-focused');

      if (input.value.trim() !== '') {
        input.classList.add('input-filled');
      } else {
        input.classList.remove('input-filled');
      }
    });

    // Initial check (in case browser autofills or input is pre-filled)
    if (input.value.trim() !== '') {
      input.classList.add('input-filled');
    }
  });
}
